import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/components/site/seo-copy";
import { CategoryPage } from "@/components/site/CategoryPage";
import { categoryBySlug } from "@/components/site/seo";

const category = categoryBySlug("sales-jobs")!;

export const Route = createFileRoute("/sales-jobs/")({
  head: () => pageHead("/sales-jobs"),
  component: () => <CategoryPage category={category} />,
});
